var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_441_39534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95728 3.41797H4.78963",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63612 8.45831V7.00524C6.63591 6.76237 6.53924 6.52949 6.36737 6.35784L4.80376 4.79362V1.58699C4.80376 1.4655 4.7555 1.34899 4.66959 1.26307C4.58368 1.17717 4.46716 1.12891 4.34567 1.12891H3.41544C3.29395 1.12891 3.17744 1.17717 3.09153 1.26307C3.00562 1.34899 2.95736 1.4655 2.95736 1.58699V4.79362L1.39374 6.35784C1.22188 6.52949 1.12521 6.76237 1.125 7.00524V13.9554C1.125 14.1984 1.22152 14.4314 1.39334 14.6032C1.56516 14.7751 1.79819 14.8716 2.04118 14.8716H4.80376",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33895 8.76172H1.13232V11.8157H4.33895V8.76172Z",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62939 13.343C6.62939 13.7479 6.79024 14.1364 7.07662 14.4227C7.36299 14.7091 7.75137 14.8699 8.15637 14.8699C8.56131 14.8699 8.94974 14.7091 9.23606 14.4227C9.52243 14.1364 9.68331 13.7479 9.68331 13.343V11.816C9.68331 11.4111 9.52243 11.0227 9.23606 10.7363C8.94974 10.4499 8.56131 10.2891 8.15637 10.2891C7.75137 10.2891 7.36299 10.4499 7.07662 10.7363C6.79024 11.0227 6.62939 11.4111 6.62939 11.816V13.343Z",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1265 14.8703L14.2642 11.8164",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.821 12.4272C11.6524 12.4272 11.5156 12.2905 11.5156 12.1218C11.5156 11.9532 11.6524 11.8164 11.821 11.8164",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.821 12.4272C11.9897 12.4272 12.1264 12.2905 12.1264 12.1218C12.1264 11.9532 11.9897 11.8164 11.821 11.8164",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5695 14.8725C14.4008 14.8725 14.2642 14.7358 14.2642 14.5672C14.2642 14.3985 14.4008 14.2617 14.5695 14.2617",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5696 14.8725C14.7382 14.8725 14.875 14.7358 14.875 14.5672C14.875 14.3985 14.7382 14.2617 14.5696 14.2617",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62939 11.8164L9.68331 13.3434",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_39534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastDrink);
export default __webpack_public_path__ + "static/media/last_drink.bbe0223f213c17da03e2f78e7c8cd84d.svg";
export { ForwardRef as ReactComponent };